import React, { useEffect } from "react";
import { signoutRedirectCallback } from "../oidcClient/userService";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { signOut } from "src/actions/authActions";

function SignoutOidc() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    async function signoutAsync() {
      await signoutRedirectCallback();
      dispatch(signOut());
      navigate(!Office.context.ui.displayDialogAsync ? "/" : "/signin-page");
    }
    signoutAsync();
  }, [navigate]);

  return <div>Redirecting...</div>;
}

export default SignoutOidc;
